import React from 'react';

import ThemeProvider from './ThemeProvider';

const PlaybookProvider: React.FC<React.PropsWithChildren> = ({ children }) => (
  <ThemeProvider>{children} </ThemeProvider>
);

export default PlaybookProvider;
